import { render, staticRenderFns } from "./MainPrint.vue?vue&type=template&id=1427a24a&scoped=true&"
import script from "./MainPrint.vue?vue&type=script&lang=js&"
export * from "./MainPrint.vue?vue&type=script&lang=js&"
import style0 from "./MainPrint.vue?vue&type=style&index=0&id=1427a24a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427a24a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VApp,VContent})
